<div class="context-popover" [class.context-popover--embedded]="embedded" *ngIf="showContextPopover" (click)="onStopPropagation($event)">

  <div class="context-source-switcher" *ngIf="selectionMode === 'attach-context' && sourceOptions.length > 1">
    <button
      *ngFor="let source of sourceOptions"
      type="button"
      class="context-source-button"
      [class.active]="activeSource === source.id"
      (click)="switchSource(source.id)">
      <i class="fa-regular" [ngClass]="source.icon"></i>
      <span>{{ source.label }}</span>
    </button>
  </div>

  <ng-container *ngIf="view === 'roots'">
    <div class="context-search">
      <div class="context-search-field">
        <i class="fa-regular fa-magnifying-glass context-search-icon" *ngIf="!isSearching"></i>
        <i class="fa-solid fa-spinner fa-spin context-search-icon" *ngIf="isSearching"></i>
        <input #searchInput
               type="text"
               class="context-search-input"
               [placeholder]="searchPlaceholder"
               [value]="searchTerm"
               (input)="onSearch($event)"
               (keydown)="onSearchKeyDown($event)">
      </div>
    </div>

    <div class="context-list">
      <div class="context-item"
           *ngFor="let root of displayedRoots; let i = index"
           [class.selected]="i === rootSelectedIndex"
           (click)="onRootClicked(root)">
        <div class="context-avatar" [class.context-avatar--fallback]="!getRootImageUrl(root)">
          <img *ngIf="getRootImageUrl(root)" [src]="getRootImageUrl(root)" [alt]="getRootLabel(root)" />
          <span *ngIf="!getRootImageUrl(root)">
            <i class="fa-regular" [ngClass]="root.icon" *ngIf="root.type === 'funnel'"></i>
            <ng-container *ngIf="root.type !== 'funnel'">{{ getRootInitial(root) }}</ng-container>
          </span>
        </div>
        <span class="context-name">{{ getRootLabel(root) }}</span>
        <i class="fa-solid fa-star context-starred-icon" *ngIf="isStarred(root)"></i>
        <i class="fa-regular fa-angle-right context-disclosure" *ngIf="canBrowseActiveSource"></i>
        <button class="context-item-action"
                type="button"
                (click)="attachRoot(root, $event)"
                [attr.aria-label]="'Attach ' + getRootLabel(root) + ' as context'">
          <i class="fa-regular fa-paperclip"></i>
          <span>Attach</span>
        </button>
      </div>
      <div class="no-context" *ngIf="!isSearching && displayedRoots.length === 0 && searchTerm">
        <i class="fas fa-magnifying-glass"></i>
        <span>No {{ emptyStateLabel }} matching "{{ searchTerm }}"</span>
      </div>
      <div class="no-context" *ngIf="!isSearching && displayedRoots.length === 0 && !searchTerm">
        <i class="fa-solid" [ngClass]="activeSource === 'business' ? 'fa-star' : activeSource === 'partner' ? 'fa-handshake' : 'fa-filter'"></i>
        <span>No {{ defaultCollectionLabel }} yet</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="view === 'items'">
    <div class="context-breadcrumb">
      <button class="context-breadcrumb-back" type="button" (click)="goBackToRoots()">
        <i class="fa-regular fa-arrow-left"></i>
      </button>
      <div class="context-breadcrumb-avatar" *ngIf="selectedRoot" [class.context-breadcrumb-avatar--fallback]="!getRootImageUrl(selectedRoot)">
        <img *ngIf="getRootImageUrl(selectedRoot)" [src]="getRootImageUrl(selectedRoot)" [alt]="getRootLabel(selectedRoot)" />
        <span *ngIf="!getRootImageUrl(selectedRoot)">
          <i class="fa-regular" [ngClass]="selectedRoot.icon" *ngIf="selectedRoot.type === 'funnel'"></i>
          <ng-container *ngIf="selectedRoot.type !== 'funnel'">{{ getRootInitial(selectedRoot) }}</ng-container>
        </span>
      </div>
      <span class="context-breadcrumb-name">{{ getRootLabel(selectedRoot) }}</span>
      <button class="context-breadcrumb-attach"
              type="button"
              *ngIf="selectedRoot"
              (click)="attachSelectedRoot($event)"
              [attr.aria-label]="'Attach ' + getRootLabel(selectedRoot) + ' as context'">
        <i class="fa-regular fa-paperclip"></i>
        <span>Attach</span>
      </button>
    </div>

    <div class="context-segments" #segmentsContainer>
      <button 
        *ngFor="let segment of segments; let i = index"
        class="segment-btn"
        [class.active]="selectedSegment === segment.id"
        [attr.data-segment-index]="i"
        (click)="selectSegment(segment.id)">
        {{ segment.label }}
        <span class="segment-count">{{ segment.count }}</span>
      </button>
    </div>
    
    <div class="context-list">
      <div class="context-item" 
           *ngFor="let item of filteredItems; let i = index"
           [class.selected]="i === currentSelectedIndex"
           [class.recently-added]="isRecentlyAdded(item)"
           (click)="selectContextItem(item, false)">
        <div class="context-icon">
          <i class="fa-solid" [ngClass]="getContextIconClass(item)"></i>
        </div>
        <span class="context-name">{{ item.displayName }}</span>
        <i class="fas fa-check added-checkmark" *ngIf="isRecentlyAdded(item)"></i>
      </div>
      <div class="no-context" *ngIf="filteredItems.length === 0">
        <i class="fas fa-inbox"></i>
        <span>No {{ selectedSegment === 'all' ? 'resources' : selectedSegment }} available</span>
      </div>
    </div>
  </ng-container>
</div>
